import React from "react"
import { render } from "react-dom"
import * as Sentry from "@sentry/browser"
import { BrowserRouter } from "react-router-dom"
import { CookiesProvider } from "react-cookie"
import { Elements as StripeElementsProvider } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { ApolloProvider } from "@apollo/client"
import moment from "moment"
import userflow from "userflow.js"
import * as serviceWorker from "./serviceWorker"

import initConfig from "./config"

import { DataClient, Version } from "./services"

// master
import Master from "./areas/Master"
import { ErrorBoundary, ErrorInitConfig, ConnectivityError, SnackbarProvider } from "./components"
import Theme from "./Theme"
import { OfflineModeProvider } from "./components/Offline/OfflineModeProvider"

// sentry applcation monitoring
if (
  !["localhost", "local.impel.co"].includes(window.location.hostname) &&
  !window.location.hostname.startsWith("192.168.")
) {
  Sentry.init({
    dsn: "https://3926b4cb78f443b48c3c11a6624f2052@o378222.ingest.sentry.io/5201332",
    environment: window.location.hostname,
  })
}

// logs
console.log(`[APP] v${Version}`)

// polyfill fromEntries
Object.fromEntries =
  Object.fromEntries ||
  function (arr) {
    return arr.reduce(function (acc, curr) {
      acc[curr[0]] = curr[1]
      return acc
    }, {})
  }

// init config
initConfig().then(
  (config) => {
    // init stripe
    const stripe = loadStripe(config.stripe.publishableKey)

    // init moment
    moment.suppressDeprecationWarnings = true

    // init userflow
    if (config.support.userflow.enabled) {
      userflow.init(config.support.userflow.token)
      userflow.setInferenceClassNameFilter((cls) => !cls.startsWith("jss"))
    }

    // create server client
    const dataClient = new DataClient(config)

    // render
    render(
      <Theme>
        <ErrorBoundary>
          <ApolloProvider client={dataClient.client}>
            <CookiesProvider>
              <SnackbarProvider>
                <StripeElementsProvider stripe={stripe}>
                  <BrowserRouter>
                    <OfflineModeProvider dataClient={dataClient}>
                      <Master />
                    </OfflineModeProvider>
                  </BrowserRouter>
                </StripeElementsProvider>
                <ConnectivityError server={dataClient} />
              </SnackbarProvider>
            </CookiesProvider>
          </ApolloProvider>
        </ErrorBoundary>
      </Theme>,
      document.getElementById("root")
    )
  },
  (err) => {
    render(
      <Theme>
        <ErrorInitConfig message={err} />
      </Theme>,
      document.getElementById("root")
    )
  }
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
